// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 2H18V6.32718L22 5.88274V14H17V22H2V8.10496L6 7.66051V2ZM8 7.43829L16 6.5494V4H8V7.43829ZM6 10.998V13.002H8.00391V10.998H6ZM10 10.998V13.002H12.0039V10.998H10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19 22H22V16H19V22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-museum-filled')
export default class MuseumFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'museum-filled',
    }
  }
}
